import { ISchemaEditorProperties } from '@src/controls/editors/SchemaEditor';
import { Col, Form, Input, Row, Space, Tabs } from 'antd';
import _ from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import RichText from './RichText';
import { getLang } from '@src/packages/pro-table/component/util';

type LanguageProps = {
  schema: ISchemaEditorProperties;
  disabled?: boolean;
  invalid?: boolean;
  value?: string[];
  onChange?: (val: any) => void;
};

const getCurrentState = async (useState: any): Promise<any> => {
  return new Promise((rs) => {
    useState((pre: any) => {
      rs(pre);
      return pre;
    });
  });
};

export default function Language({
  schema,
  disabled,
  invalid,
  value = [],
  onChange,
}: LanguageProps) {
  const [form] = Form.useForm();
  const valueRef = useRef<any>({});
  const [valueState, setValueState] = useState<any>({});
  const timeRef = useRef<any>();
  const { language = [], keyword = [] } = schema;

  const locale = getLang();
  const currentLocale = locale.split('-')[0];

  useEffect(() => {
    language.forEach((lang) => {
      keyword.forEach((field) => {
        valueRef.current[lang.language] = {
          ...valueRef.current[lang.language],
          language: lang.language,
          [field.keyword]: '',
        };
      });
    });
  }, [language, keyword]);

  useEffect(() => {
    if (!value.length) return;
    value.forEach((val: any) => {
      for (const key in val) {
        if (key === 'language') continue;
        if (form.getFieldValue(`${val.language}-${key}`)) continue;
        form.setFieldsValue({
          [`${val.language}-${key}`]: val[key],
        });
        valueRef.current[val.language][key] = val[key];
      }
    });
  }, [value]);

  const onChangeKeyword = (lang: string, field: string, val: string) => {
    valueRef.current[lang][field] = val;
    clearTimeout(timeRef.current);
    timeRef.current = setTimeout(() => {
      onChange && onChange(Object.values(valueRef.current));
    }, 1000);
  };

  return (
    <Form form={form}>
      <Tabs defaultActiveKey='1'>
        {language.map((lang) => (
          <Tabs.TabPane tab={lang.label.toLocaleUpperCase()} key={lang.uuid}>
            <Row align='middle' gutter={[12, 12]}>
              {keyword.map((field) => {
                let fieldLabel = field.label;
                if (
                  field.label.includes('&') &&
                  field.label.includes(`${currentLocale}=`)
                ) {
                  field.label.split(`&`).forEach((lang: string) => {
                    if (lang.includes(`${currentLocale}=`)) {
                      fieldLabel = lang.split(`=`)[1];
                    }
                  });
                }
                return (
                  <React.Fragment key={field.uuid}>
                    <Col span={5}>{fieldLabel}:</Col>
                    <Col span={19}>
                      <Form.Item name={`${lang.language}-${field.keyword}`}>
                        {!field.richtext ? (
                          <Input.TextArea
                            placeholder='value'
                            style={{ height: 40 }}
                            onChange={(e) => {
                              e.preventDefault();
                              onChangeKeyword(
                                lang.language,
                                field.keyword,
                                e.target.value
                              );
                            }}
                          />
                        ) : (
                          <CustomRichText
                            onChangeValue={(value: any) => {
                              onChangeKeyword(
                                lang.language,
                                field.keyword,
                                value
                              );
                            }}
                          />
                        )}
                      </Form.Item>
                    </Col>
                  </React.Fragment>
                );
              })}
            </Row>
          </Tabs.TabPane>
        ))}
      </Tabs>
    </Form>
  );
}

const CustomRichText = ({ value = {}, onChangeValue, onChange }: any) => {
  const refTime = useRef<any>();
  return (
    <RichText
      value={value}
      onChange={(e) => {
        onChangeValue(e);
        clearTimeout(refTime.current);
        refTime.current = setTimeout(() => {
          onChange(e);
        }, 1500);
      }}
    />
  );
};
